import React from 'react'

export const useUserData = () => {
  const [user, setUser] = React.useState(null)
  const [skipedLogin, setSkipedLogin] = React.useState(false)

  React.useEffect(() => {
    if (!window.isMobile && window._env_.BFF_ENABLE === '1') {
      fetch('/system/user', {
        headers: {
          'X-CSRF': '1'
        }
      })
      .then((res) => res.json())
      .then(user => {
        setUser(user)
      })
      .catch(() => {
        console.log('Getting login ....')
        window.location.replace('/system/login')
      })
    } else {
      setSkipedLogin(true)
    }

    return () => {
      setUser(undefined)
      setSkipedLogin(undefined)
    }
  }, []);

  return { user, skipedLogin }
}
